import * as React from 'react';
import Textbox from 'src/components/controls/forms/redesign/FormTextbox';
import TextArea from 'src/components/controls/forms/redesign/FormTextArea';
import NewTract from 'src/models/tract_detail/NewTract';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import Form from 'src/components/controls/forms/Form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import FormRow from 'src/components/controls/forms/FormRow';

import './AddTract.scss';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import County from 'src/models/County';
import PagedResultSet from 'src/models/common/PagedResultSet';
import PropertyUtil from 'src/util/PropertyUtil';
import { SelectItem } from 'src/models/common/SelectItem';
import { AnyObject } from 'final-form';
import { FormErrors } from 'src/util/FormErrors';

export interface IAddTractProps {
    createTract: (values: NewTract) => void;
    hideDialog: () => void;
    sectionCounties: PagedResultSet<County>;
    sectionNumber: number;
    mapNumber: number;
}

export default class AddTract extends React.Component<IAddTractProps> {
    handleSubmit = (values: NewTract) => {
        values.grossAcres = parseFloat(values.grossAcres + '');
        values.mapNumber = this.props.mapNumber;
        values.sectionNumber = this.props.sectionNumber;
        this.props.createTract(values);
        this.props.hideDialog();
    };

    validate = (values: AnyObject) => {
        const errors: AnyObject = {};

        if (!values.tractName) {
            errors.tractName = 'Tract Name is required!';
        }

        return errors as FormErrors;
    };

    render() {
        const selectSectionCounties = PropertyUtil.SafeGet(() => this.props.sectionCounties.items.map((c: County) => new SelectItem(c.id, c.name)));

        return (
            <Dialog title="Create New Tract" dialogName={DialogList.ADD_TRACT}>
                <Form
                    onSubmit={this.handleSubmit}
                    initialValues={{
                        countyId: this.props.sectionCounties?.items?.length === 1 ? this.props.sectionCounties.items[0].id : undefined,
                    }}
                    validate={this.validate}
                >
                    <FormRow>
                        <Textbox name="tractName" label="Tract Name" isRequired={true} />
                        <Textbox name="grossAcres" label="Gross Acres" />
                    </FormRow>
                    <FormSelect label="County" name="countyId" items={selectSectionCounties ? selectSectionCounties : []} />
                    <TextArea name="legalDescription" label="Legal Description" width="100%" height="9rem" />

                    <FormRow className="mt-2">
                        <Button type="submit" text="Create Tract" />
                    </FormRow>
                </Form>
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/AddTract.tsx